import React, { Component } from 'react';
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';

import texts from '../../data/texts';

class SignupOrganisation extends Component {

  constructor(props){
    super(props);
    this.state = {
      email: '',
      valid: false,
      error: false,
      show: false,
      mitarbeiter: 0,
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if(!this.state.valid){
      this.setState({error: 'Bitte gib eine gültige E-Mail-Adresse ein.'});
    }

    const url = process.env.REACT_APP_API_HOST;

    const params = new URLSearchParams({
      email: this.state.email,
      data: JSON.stringify({
        type:'organisation',
        mitarbeiter: this.state.mitarbeiter
      })
    });

    if(this.state.valid) {
      fetch(url+"/pro/subscribe", {
				method: 'post',
				body: params
			}).then(() =>
        this.setState({
          email: '',
          valid: false,
          show: false,
          error: false
        })
      );
    }
  }

  validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  handleKey = (e) => {
    this.setState({
      email: e.target.value,
      valid: this.validateEmail(e.target.value)
    });
  }

  toggle = () => {
    this.setState({show: !this.state.show});
  }

  render(){
    return (
      <React.Fragment>
        { this.props.sublineText ?
          <Button color="primary" outline className={ this.props.className || "shadow-sm" } onClick={() => this.setState({show: true})}>{ texts.orga_cta_subline }</Button>
          :
          <Button color="primary" outline className={ this.props.className || "shadow-sm" } onClick={() => this.setState({show: true})}>{ texts.orga_cta_text }</Button>
        }
        <Modal isOpen={this.state.show} toggle={this.toggle} size="lg" className="modal-dialog-centered border-0">
          <ModalBody className="bg-secondary-dark text-center p-3 p-md-5 shadow">
            <Button color="link" onClick={this.toggle} style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}>
              <i className="fas fa-times" style={{ color: '#c8c8c8' }}></i>
            </Button>
            <Container>
              <Row className="justify-content-md-center">
                <Col xs="12" lg="8">

                  <img src='/imgs/paul_logo_color_small.svg' style={{width: '80px', height: 'auto'}} className='mb-4' />
                  { this.state.submit
                  ?
                    <div>
                      <div className='notification is-success'>
                        <h2 className="text-white mb-3">Vielen Dank für Ihr Interesse an Paul!</h2>
                        <p className="text-white mb-5">Nach dem offiziellen Start des Services erhalten Sie einen Gutscheincode um sich den Startpreis zu suchern!</p>
                      </div>
                    </div>
                  :
                    <div className="pb-3">
                      <h2 className="text-white mb-2">{ texts.orga_signup.modal_headline }</h2>
                      <h5 className="text-white mb-5">{ texts.orga_signup.modal_subline }</h5>

                      <FormGroup className="mb-2 text-left">
                        <Label for="mitarbeiterSelect" className="text-white"><small>{ texts.orga_signup.mitarbeiter_label }</small></Label>
                        <Input type="select" id="mitarbeiterSelect" className="shadow" onChange={(e) => this.setState({mitarbeiter: e.target.value})}>
                          <option value="0">–</option>
                          <option value="1-10">1-10 Mitarbeiter</option>
                          <option value="10–50">10–50 Mitarbeiter</option>
                          <option value="50–100">50–100 Mitarbeiter</option>
                          <option value="100–500">100–500 Mitarbeiter</option>
                          <option value="500–1000">500–1000 Mitarbeiter</option>
                          <option value="1000+">1000+ Mitarbeiter</option>
                        </Input>
                      </FormGroup>

                      <input className='form-control mb-2 shadow' type="email" placeholder={ texts.orga_signup.email_placeholder } onKeyUp={(e) => this.handleKey(e)}/>
                      <button
                        className='btn btn-primary btn-block shadow'
                        type='button'
                        onClick={this.handleSubmit}
                        value={this.state.email}
                      >{ texts.orga_signup.modal_button }
                      </button>
                      {this.state.error && <small id="emailHelp" className="form-text text-secondary text-left mt-2">{ this.state.error }</small>}
                    </div>
                  }

                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter className="bg-white text-center justify-content-center">
            <small className="text-secondary" dangerouslySetInnerHTML={{__html: texts.orga_signup.small_text.join('<br />')}}></small>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

export default SignupOrganisation;



// WEBPACK FOOTER //
// ./src/components/modals/SignupOrganisation.js